import React, {useState} from "react";
import {Table, TableCell as Cell,} from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from './tableCell';
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {withRouter} from "react-router-dom";
import {useStyles} from "./cpManagementDataTableStyle";
import TableHeading from './tableHeading';
import './styles.scss'
import {DeleteIcon} from '../../assets/images/images'
import EditIcon from "@material-ui/icons/Edit";
import {Status} from '../'

function OrdersDataTable(props) {
  const {data = {}, pagination = {}, tableName} = props;
  console.log(tableName)
  const {rows, column, smart} = data;
  let {totalRows, pageNo, onPageChange, pageSize, onPageSizeChange} = pagination;

  let headCells = column;
  const classes = useStyles();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  const [actionRowId, setActionRowId] = useState(null)

  const emptyRows = pageSize - Math.min(pageSize, totalRows - pageNo * pageSize);
  const handleChangePage = (event, newPage) => onPageChange(newPage + 1)
  const changePageSizeHandler = ({target: {value}}) => onPageSizeChange(value)
  const detail = (row, action) => {
    console.log(row, action)
    // props.history.push({pathname: `/users/${id}`});
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={[classes.table, ' datatable-body']}
            stickyHeader={true} aria-label="sticky table"
          >
            <TableHeading
              classes={classes}
              rowCount={rows?.length || 0}
              columns={headCells}
              rows={rows}
            />
            <TableBody>
              {
                (rows || []).map((row, index) => {
                  let [status, statusColor] = row?.status == 1 ? ['active', ' color-green'] : ['in-active', 'color-red'];

                  return (
                    <TableRow hover key={row.orderId + index} className='cursor-pointer'>
                      {smart ?
                        <>
                          <TableCell value={row?.orderNumber} row={row}/>
                          <TableCell value={row?.orderGroupNumber} row={row}/>
                          <TableCell value={row?.bidDate} row={row}/>
                          <TableCell value={row?.harvestUnitPrice} row={row}/>
                        </> :
                        tableName === 'my orders' ? <>
                            <TableCell value={row?.orderNumber} row={row}/>
                            <TableCell value={row?.shippingAddress} row={row}/>
                            {/*<TableCell value={row?.orderGroupNumber} row={row}/>*/}
                            <TableCell value={row?.harvestUnitPrice} row={row}/>
                            <TableCell value={row?.harvestUnitPrice} row={row}/>
                            <TableCell value={row?.bidDate} row={row}/>
                            {/*<TableCell value={row?.shippingAddress} row={row}/>*/}
                            <TableCell children={
                              <Status statusText={status} textColor={statusColor}
                                      statusColor={statusColor}/>}
                                       row={row}
                            />

                            <TableCell children={<DeleteIcon titleAccess='delete' className={classes.actionIcon}
                                                             onClick={() => detail(row.id)}/>}/>
                          </> :
                          <>
                            <TableCell value={row?.orderNumber} row={row}/>
                            <TableCell value={row?.shippingAddress} row={row}/>
                            <TableCell value={row?.harvestUnitPrice} row={row}/>
                            <TableCell value={row?.harvestUnitPrice} row={row}/>

                            {/*<TableCell value={row?.orderGroupNumber} row={row}/>*/}
                            <TableCell value={row?.bidDate} row={row}/>
                            <TableCell children={
                              <Status statusText={status} textColor={statusColor}
                                      statusColor={statusColor}/>}
                                       row={row}
                            />
                            {/*<TableCell value={row?.shippingAddress} row={row}/>*/}
                            <Cell
                              className="text-capitalize table-more-option-btn-container text-center border-none p-0">
                              <button
                                className="table-more-option-btn"
                                onClick={() => {
                                  setActionRowId(() => {
                                    console.log(row.orderNumber)
                                    if (actionRowId === row.orderNumber)
                                      setActionRowId(null)
                                    else
                                      setActionRowId(row.orderNumber)
                                  })
                                }}
                              > ...
                              </button>
                              <div
                                className={actionRowId === row.orderNumber ? 'button-container' : 'display-none'}>
                                <div className='flex-row-center  edit' onClick={() => detail(row, 'Edit')}>
                                  <EditIcon titleAccess={'edit'} className={classes.actionIcon}/>
                                  <span className='pl-5'> Edit</span>
                                </div>
                                <div className='flex-row-center  edit' onClick={() => detail(row, 'delete')}>
                                  <DeleteIcon titleAccess='Delete' className={classes.actionIcon}
                                              onClick={() => detail(row.id)}/>
                                  <span className='pl-5'> Delete</span>
                                </div>
                              </div>
                            </Cell>
                          </>
                      }

                    </TableRow>
                  );
                })
              }
              {(!rows || rows.length == 0) && (
                <>
                  <>No Data Found</>
                </>
              )}
              {/*{emptyRows && <EmptyRows emptyRows={1} colSpan={6}/>*/}
              {/*}*/}
            </TableBody>
          </Table>
        </TableContainer>
        {/*<Pagination*/}
        {/*  rowsPerPageOptionList={[5, 10]}// to show rows change per page send array otherwise option will be hidden*/}
        {/*  component="div"*/}
        {/*  totalRowsInDb={totalRows}*/}
        {/*  pageSize={pageSize}*/}
        {/*  onPageSizeChange={changePageSizeHandler}*/}
        {/*  pageNo={pageNo}*/}
        {/*  onPageChangeHandler={handleChangePage}*/}
        {/*/>*/}
      </Paper>
    </div>
  );
}

export default withRouter(
  (OrdersDataTable)
);
